import React, { FC } from "react";
import styled from "@emotion/styled";
import ContentBody from "./components/ContentBody";
import { useGetReportOverviewCancel } from "hooks/useDashboard";

interface CardCancelProps {
  selectPeriod: string;
  daterangePicker: [string, string]
}

const CardCancel: FC<CardCancelProps> = ({daterangePicker, selectPeriod }) => {

    const { data, isLoading } = useGetReportOverviewCancel({ period: selectPeriod, start_date: daterangePicker[0], end_date: daterangePicker[1]  });

    
    const convertSelectPeriod = (selectPeriod: string) => {
      switch (selectPeriod) {
        case "month":
          return "เดือนนี้";
        case "year":
          return "ปีนี้";
      }
    };

  return (
    <CardWrapper>
      <CardHeaderWrapper>
        <WrapperTextHeader>รายการยกเลิก</WrapperTextHeader>
      </CardHeaderWrapper>
      <RowPercentWrapper>
      <WrapperRow>
          <WrapperBackground>
            <WrapperTextPercent>
              <TextPositive>{convertSelectPeriod(selectPeriod)}</TextPositive>
            </WrapperTextPercent>
          </WrapperBackground>

          <WrapperBackground>
            <WrapperTextPercent>
              <TextPositive>{data?.data?.count_all}</TextPositive>
            </WrapperTextPercent>
          </WrapperBackground>
        </WrapperRow>
      </RowPercentWrapper>
      <ContentBody data={data?.data} />
    </CardWrapper>
  );
};

export default CardCancel;

const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 20px 20px 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

const CardHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const RowPercentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const TextPositive = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: #f1500f;
  @media (min-width: 1920px) {
    font-size: 17px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 16px;
  }
  @media (min-width: 481px) and (max-width: 767px) {
    font-size: 15px;
  }
  @media (max-width: 480px) {
    font-size: 14px;
  }
  @media (min-width: 481px) and (max-width: 991px) {
    font-size: 15px;
  }
`;

const WrapperIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
`;

const WrapperTextPercent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperTextHeader = styled.p`
  font-size: 25px;
  font-weight: 400;
  @media (min-width: 1920px) {
    font-size: 23px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 21px;
  }
  @media (min-width: 481px) and (max-width: 767px) {
    font-size: 19px;
  }
  @media (max-width: 480px) {
    font-size: 17px;
  }
  @media (min-width: 481px) and (max-width: 991px) {
    font-size: 18px;
  }
`;

const WrapperBackground = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #fcddca;
  border-radius: 8px;
  padding: 2px 5px 2px 5px;
`;
